/* src/app/modules/subscription/add-coupon-dialog/add-coupon-dialog.component.css */
.add-coupon-dialog {
  padding: 22px 22px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.dialog-title {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
  color: #0f172a;
}
.dialog-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 0.92rem;
  line-height: 1.4;
}
.dialog-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.dialog-field label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
}
.dialog-field .form-control {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.92rem;
  box-shadow: none;
}
.dialog-field .form-control:focus {
  border-color: var(--cf-brand-dark);
  box-shadow: 0 0 0 3px rgba(212, 143, 0, 0.15);
}
.dialog-note {
  margin: 2px 0 0;
  font-size: 0.8rem;
  color: #94a3b8;
}
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
}
.btn-back {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  border-radius: 8px;
  padding: 9px 14px;
  font-weight: 600;
  cursor: pointer;
}
.btn-confirm {
  border: none;
  background: var(--cf-brand-dark);
  color: #fff;
  border-radius: 8px;
  padding: 9px 16px;
  font-weight: 700;
  cursor: pointer;
}
.btn-confirm[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
/*# sourceMappingURL=add-coupon-dialog.component.css.map */
